export const supportEmail = 'employerindex@socialmobility.org.uk';
// export const signUpUrl = 'https://www.socialmobility.org.uk/employerindex';
export const signUpUrl = import.meta.env.VITE_SIGN_UP_URL;
